import { useQuery, useMutation } from "@tanstack/react-query";
import { X } from "lucide-react";
import { apiRequest, queryClient } from "@/lib/queryClient";
import { useUser } from "@/lib/user-context";
import type { ReprintAlert } from "@shared/schema";

const TARGET_SPECIALTIES = ["ink_mixer", "screen_burner", "press_operator"];

export function ReprintAlertBanner() {
  const { specialties, isRoleLoaded } = useUser();

  const hasTargetSpecialty = (specialties || []).some((s: string) =>
    TARGET_SPECIALTIES.includes(s),
  );

  const { data: alerts } = useQuery<ReprintAlert[]>({
    queryKey: ["/api/reprint-alerts"],
    enabled: isRoleLoaded && hasTargetSpecialty,
    refetchInterval: 30_000,
  });

  const ackMutation = useMutation({
    mutationFn: (alertId: string) =>
      apiRequest("POST", `/api/reprint-alerts/${alertId}/acknowledge`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["/api/reprint-alerts"] });
    },
  });

  if (!hasTargetSpecialty || !alerts || alerts.length === 0) return null;

  return (
    <div className="flex flex-col">
      {alerts.map((alert) => (
        <div
          key={alert.id}
          className="flex items-center justify-between gap-3 px-4 py-2.5 text-sm font-semibold text-white"
          style={{ backgroundColor: "#dc2626" }}
        >
          <span>{alert.message}</span>
          <button
            className="shrink-0 rounded-full p-1 hover:bg-white/20 transition-colors"
            onClick={() => ackMutation.mutate(alert.id)}
            title="Acknowledge"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
